export const updateMessengerUrl = (conversationId: any, navigate: any) => {
  const params = new URLSearchParams(window.location.search);
  params.set('conversationId', conversationId);
  navigate({
    pathname: window.location.pathname,
    search: `?${params.toString()}`,
  });
};
